export default function fSetUrlQuery(queryFilter: any, queryRouter: any) {
    const queryData = {
        ...JSON.parse(JSON.stringify(queryFilter)),
        ...JSON.parse(JSON.stringify(queryRouter)),
    };
    Object.keys(queryFilter).forEach((item) => {
        if (!queryFilter[item]) {
            delete queryData[item];
        } else {
            queryData[item] = queryFilter[item];
        }
    });
    return queryData;
}
